module.exports = __webpack_public_path__ + "static/oop_encap_abstraction-4ac5982917b429d4457fcdc6991c2db6.png";